.split {
  display: grid;
  gap: var(--sp-8);
  align-items: center;
}
.text {
  display: grid;
  gap: var(--sp-4);
}
.body :global(ul) {
  display: grid;
  gap: var(--sp-2);
  padding-left: 1.25rem;
  list-style: disc;
}
.picture {
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}
@media (min-width: 64rem) {
  .split {
    grid-template-columns: 1fr 1fr;
    gap: var(--sp-16);
  }
  .reverse .text {
    order: 2;
  }
}
